export const PROMOTION_PAGE_DEFAULT = 1;
export const PROMOTION_PER_PAGE_DEFAULT = 100;
export const PromotionEffectType = {
  AUTOMATIC_DISCOUNT: "automatic_discount",
  BUY_X_GET_Y: "buy_x_get_y"
};
